import { useEffect } from "react";
import { getCookieValueByName } from "utils/getCookieValueByName";

import config from "config";

import { initialiseGTM } from "../googleTagManager.js";

export const useGTM = () => {
  const GA4ClientId = getCookieValueByName(
    `_ga_${config.GA_TRACKING_ID_CONSOLIDATED_STREAM}`
  );
  const UAClientId = getCookieValueByName("_ga");

  useEffect(() => {
    if (config.GTM_ID && config.ENVIRONMENT === "Production") {
      initialiseGTM();
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const dataLayer = (window as any).dataLayer || [];
      dataLayer.push({
        event: "page_view",
        GA4ClientId,
        UAClientId,
        pardotId: getCookieValueByName(`visitor_id${config.PARDOT_A_ID}`),
        hubspotId: getCookieValueByName("hubspotutk"),
      });
    }
  }, [GA4ClientId, UAClientId]);

  return { GA4ClientId, UAClientId };
};
